<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="before-you-begin">
<h1>Before You Begin</h1>
<p>There are all sorts of things to think about before you even encounter pupils. I recognise that this might be frustrating if you want to get stuck into the practicalities of dealing with pupils but, and it’s an important ‘but’, getting a few things straight before the first pupil comes into your classroom is really important. They are all a part of practising the art of successful classroom management and they do have an impact on your day-to-day teaching.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?7ba3d384